import { z } from 'zod';

export type ExerciseType = 'carga' | 'tempo' | 'repeticao' | 'distancia' | 'calorias';

export interface ImageValue {
  uri: string;
  uriOriginal?: string;
  height?: number;
  width?: number;
}

export interface VideoValue {
  uri: string;
}

export interface FileProps {
  url?: string;
  preview?: string;
  path?: string;
  externalUrl?: string;
  type?: string;
}

export interface ExerciseProps {
  id?: string;
  name: string;
  description: string;
  recordEnabled: boolean;
  exerciseType?: ExerciseType;
  image?: ImageValue;
  video?: VideoValue;
  imageUrl?: string;
  videoUrl?: string;
  externalVideoUrl?: string;
}

export const exerciseFormSchema = z.object({
  name: z.string({
    required_error: 'Nome é obrigatório',
  }),
  description: z.string({
    required_error: 'Descrição é obrigatória',
  }),
  imageUrl: z.string().optional(),
  videoUrl: z.string().optional(),
  recordEnabled: z.boolean(),
  exerciseType: z.string().optional(),
});

export type ExerciseFormValues = z.infer<typeof exerciseFormSchema>;

export interface MediaComponentProps {
  handleMediaUpdate: (mediaType: string, file: any) => void;
  image?: FileProps;
  video?: FileProps;
} 